import { render, staticRenderFns } from "./FlexTouchVideo.vue?vue&type=template&id=4eab3d9e&scoped=true&"
import script from "./FlexTouchVideo.vue?vue&type=script&lang=js&"
export * from "./FlexTouchVideo.vue?vue&type=script&lang=js&"
import style0 from "./FlexTouchVideo.vue?vue&type=style&index=0&id=4eab3d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eab3d9e",
  null
  
)

export default component.exports